export default __webpack_public_path__ + "static/media/mc_img_04.42231acf.png";